var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMileage32 = function SvgMileage32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.887 27a13.505 13.505 0 0 1-2.818-6.962 13.409 13.409 0 0 1 1.355-7.37A13.795 13.795 0 0 1 8.546 7.1 14.24 14.24 0 0 1 15.901 5c2.604-.018 5.16.674 7.384 1.998a13.808 13.808 0 0 1 5.203 5.497 13.414 13.414 0 0 1 1.461 7.35c-.222 2.535-1.319 5.114-2.873 7.155",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.79 14a.836.836 0 0 0-.56.223.75.75 0 0 0-.171.245.715.715 0 0 0-.059.288.73.73 0 0 0 .056.262c.349.853 1.032 2.72 1.7 4.494.334.89.664 1.752.941 2.468.209.556.458 1.098.744 1.622.72 1.174 2.227 1.778 3.45 1.138 1.22-.667 1.413-2.223.679-3.387-.335-.497-.707-.97-1.111-1.418a130.17 130.17 0 0 0-1.784-2.014c-1.295-1.436-2.67-2.93-3.296-3.636a.794.794 0 0 0-.279-.208.84.84 0 0 0-.347-.073l.038-.004Z",
    fill: "currentColor"
  })));
};
export default SvgMileage32;